import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconTwitter = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 15 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M14.9,2.9c-0.6,0.2-1.1,0.4-1.7,0.5c0.6-0.4,1.1-1,1.3-1.7c-0.6,0.4-1.2,0.6-1.9,0.7     c-1.1-1.2-3.1-1.3-4.3-0.1C7.5,3.1,7.1,4.2,7.4,5.2C5,5.1,2.7,3.9,1.1,2.1c-0.8,1.4-0.4,3.2,0.9,4c-0.5,0-1-0.1-1.4-0.4     c0,0,0,0,0,0c0,1.4,1,2.7,2.4,3C2.7,8.8,2.2,8.9,1.8,8.8c0.4,1.2,1.5,2.1,2.8,2.1c-1.1,0.8-2.4,1.3-3.8,1.3c-0.2,0-0.5,0-0.7,0     c1.4,0.9,3,1.4,4.6,1.4c4.7,0,8.6-3.8,8.6-8.5c0,0,0-0.1,0-0.1c0-0.1,0-0.3,0-0.4C14,4.1,14.5,3.5,14.9,2.9"
	})
});
export { SvgIconTwitter as ReactComponent };
